import React, { useState } from "react";
import {
  ButtonHLPure,
  TextAreaHLPure,
  DialogSystemGLPure,
  SubtitlePageHLPure,
} from "../../../pures";
import { Grid } from "@material-ui/core";
import { profileIconDefault } from "../../../../assets/logos/icons";
import "./user-administration-disable-user.view.css";
import { useTranslation } from "react-i18next";

const UserAdministrationDisableUserView = ({
  hideShowDetails,
  selectedUser,
  saveStatusForUser,
  token,
  showDetailComponent,
  toggleShowDetailComponent,
  imgProfileSubtitle,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  message,
}) => {
  const { t } = useTranslation()
  const [comments, setComments] = useState("");
  const handleChangeComments = (e) => {
    setComments(e.target.value);
  };

  const handleSave = () => {
    const body = {
      email: selectedUser.email,
      status: !selectedUser.active,
      comments: comments,
    };

    saveStatusForUser(token, body);
  };

  return (
    <Grid
      item
      lg={12}
      md={12}
      sm={12}
      xs={12}
      className="userAdministrationDisableUserView-wrapper"
    >
      <>
        <Grid
          item
          lg={12}
          md={12}
          xs={12}
          sm={12}
          className="userAdministrationDisableUserView-header"
        >
          <SubtitlePageHLPure
            subtitle={
              selectedUser.firstName !== "" ||
                (selectedUser.firstName !== null &&
                  selectedUser.firstLastName !== "") ||
                selectedUser.secondLastName !== ""
                ? `${t("userAdministrationDisableUserView.title.disable.to")} ${selectedUser.name}`
                : t("userAdministrationDisableUserView.title.disable.user")
            }
            imgProfile={profileIconDefault}
            profileImg={imgProfileSubtitle}
            tooltipShow
            informationIcon={false}
            justShowImg
            openTooltipDescription={false}
          />
        </Grid>
        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          es={12}
          className="userAdministrationDisableUserView-body"
        >
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationDisableUserView-form"
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="userAdministrationDisableUserView-textAreaHLPure"
            >
              <TextAreaHLPure
                labelTextArea={
                  selectedUser.active
                    ? `${t("digitalContractDashboard.questionnaires.disableReason")} * ` + "" + selectedUser.name
                    : t("userAdministrationDisableUserView.reason.enabling") + "" + selectedUser.name
                }
                valueTextData={comments}
                handleChangeTextArea={(e) => handleChangeComments(e)}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="userAdministrationDisableUserView-btnGroup"
          >
            <Grid className="userAdministrationDisableUserView-spaceBtns">
              <ButtonHLPure
                nameBtn={t("button.return")}
                onClickBtn={
                  showDetailComponent
                    ? toggleShowDetailComponent
                    : hideShowDetails
                }
              />
            </Grid>
            <ButtonHLPure
              primary
              nameBtn={selectedUser.active ? t("userAdministrationDisableUserView.btn.disable") : t("userAdministrationDisableUserView.btn.enable")}
              onClickBtn={handleSave}
            />
          </Grid>
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            message={message}
          />
        </Grid>
      </>
    </Grid>
  );
};

export default UserAdministrationDisableUserView;
